<template>
    <div>
        <b-list-group class="suggestions">
            <div v-for="(item, index) in list" :key="index" class="mb-2">
                <b class="font-weight-semi-bold ml-4">{{ item.title }}</b>
                <div class="ml-4">{{ item.info }}</div>
                <b-list-group-item button
                    class="d-flex justify-content-between"
                    @click="choose(item)">
                    <div class="d-flex flex-wrap symbols" :class="`symbols-${game.name}`">
                        <span class="symbol mr-1 mb-1" v-for="(studioItemId, index) in item.symbols" :key="index">{{ studiosItems[studioItemId].symbol }}</span>
                    </div>
                    <b-button variant="link">
                        {{ 'suggestions.use' | lang }}
                    </b-button>
                </b-list-group-item>
            </div>
        </b-list-group>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: ['gameId', 'countId'],

    computed: {
        ...mapState(['channels', 'shopsGames']),
        
        game() {
            return Config.games[this.gameId];
        },

        count() {
            const count = this.game.counts[this.countId];
            if (count) {
                return count.count;
            }
        },

        studiosItems() {
            const items = {};
            for (const [ itemId, item ] of Object.entries(this.game.items)) {
                items[item.studio_item_id] = { id: itemId, symbol: item.symbol, flask: item.flask };
            }
            return items;
        },

        list() {
            if (!this.count) {
                return [];
            }

            const stats = this.channels[this.game.channel_id].stats;
            const probableStats = this.channels[this.game.channel_id] ? this.channels[this.game.channel_id].probable_stats : null;
            const guessedStats = this.shopsGames[this.game.shop_game_id] ? this.shopsGames[this.game.shop_game_id].guessed_stats : null;
            const lang = this.$options.filters.lang;

            const list = [];

            if (stats && stats[500]) {
                list.push({
                    title: lang('suggestions.stats_title'),
                    info: lang('suggestions.stats_info'),
                    symbols: this.filterStats(stats[500]),
                });
            }

            if (probableStats) {
                list.push({
                    title: lang('suggestions.probable_title'),
                    info: lang('suggestions.probable_info'),
                    symbols: this.filterStats(probableStats),
                });
            }

            if (guessedStats) {
                list.push({
                    title: lang('suggestions.guessed_title'),
                    info: lang('suggestions.guessed_info'),
                    symbols: this.filterStats(guessedStats),
                });
            }

            return list;
        },
    },

    methods: {
        choose(item) {
            const ids = item.symbols.map(studioItemId => {
                return this.studiosItems[studioItemId].id.toString();
            });
            this.$emit('choose', ids);
        },

        filterStats(stats) {
            let sorted = Object.entries(stats)
                .sort((a, b) => b[1] - a[1])
                .filter(([ itemId ]) => this.studiosItems[itemId])
                .filter(([ itemId ]) => this.studiosItems[itemId].symbol != '*');

            if (this.game.name == 'Jokerjackpot') {
                let flasked = {};
                for (const [ itemId, count ] of sorted) {
                    const { flask } = this.studiosItems[itemId];
                    if (!flasked[flask]) {
                        flasked[flask] = [ itemId, count ];
                    }
                    if (Object.keys(flasked).length >= 6) {
                        break;
                    }
                }
                sorted = Object.values(flasked);
            }

            const sliced = sorted.map(([ itemId ]) => itemId).slice(0, this.count);

            if (this.game.name != 'Jokerjackpot') {
                return sliced.sort((firstId, secondId) => parseInt(this.studiosItems[firstId].symbol) > parseInt(this.studiosItems[secondId].symbol) ? 1 : -1);
            }

            return sliced;
        },
    },
}
</script>